<template>
  <div id="container" class="library_st_detail">
    <!-- Location START -->
    <div class="location_wrap">
      <div class="location">
        <button type="button" class="btn_open_snb">
          {{ $t('views.library.mynotedetail.5590') }}
        </button>
        <span>{{ $t('views.library.mynotedetail.9901') }}</span>
        <span class="svg_next">></span>
        <span>노트</span>
        <span class="svg_next">></span>
        <div v-on-clickaway="closeListMenu" class="current">
          <div class="select_area">
            <div class="select_item" :class="{ active: showListMenu }">
              <button
                type="button"
                class="select_option"
                @click="toggleListMenu"
              >
                <span>{{ $t('views.library.mynotedetail.5596') }}</span
                ><span class="arrow blind">열기</span>
              </button>
              <ul class="select_list">
                <li>
                  <a href="javascript:void(0)">{{
                    $t('views.library.mynotedetail.427')
                  }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)">{{
                    $t('views.library.mynotedetail.1108')
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span class="svg_next">></span>
        <span>{{ $t('views.library.mynotedetail.7618') }}</span>
      </div>
    </div>
    <!-- Location END -->

    <!-- 도서 기본 정보 -->
    <div class="section full">
      <div class="inner">
        <div class="detail_book">
          <div class="eplist note">
            <div>
              <div class="cover_wrap" :class="{ best: note.isBest }">
                <!-- <div class="thum_wrap">
                  <img
                    src="@/assets/images/cover/temp_book_cover6.jpg"
                    alt="세계의 몸짓 몸짓의 세계"
                  />
                </div> -->
              </div>
              <div class="text_label outline">
                <label
                  ><input
                    v-model="note.sharing"
                    type="checkbox"
                    name="sharing"
                    class="chk_agree"
                  /><em></em
                  ><span class="tt">{{
                    $t('views.library.mynotedetail.1153')
                  }}</span></label
                >
              </div>
            </div>
            <div>
              <div class="info_wrap">
                <div class="row">
                  <p class="iconbox">
                    <span
                      class="meta_editer book"
                      :class="{ active: note.hasPaper }"
                      ><span class="an_i"></span
                      ><span class="an_t">{{
                        $t('views.library.mynotedetail.book')
                      }}</span></span
                    >
                    <span
                      class="meta_editer epub"
                      :class="{ active: note.hasEbook }"
                      ><span class="an_i"></span
                      ><span class="an_t">{{
                        $t('views.library.mynotedetail.ebook')
                      }}</span></span
                    >
                    <span
                      class="meta_editer pod"
                      :class="{ active: note.hasPod }"
                      ><span class="an_i"></span
                      ><span class="an_t">{{
                        $t('views.library.mynotedetail.pod')
                      }}</span></span
                    >
                  </p>
                  <h3 class="meta_title">{{ book.title }}</h3>
                  <p class="meta_author">
                    {{ book.author }}
                  </p>
                  <p class="meta_publisher">{{ book.publisher }}</p>
                  <p class="meta_date">{{ book.date }}</p>

                  <p class="meta_rate">
                    <span class="score_wrap">
                      <span class="score_box"
                        ><span class="score_fill" style="width: 50%;"></span
                      ></span>
                      <span class="score_score">{{ book.rating }}</span
                      ><span class="blind">{{ $t('common.ui.rating') }}</span>
                      <span class="score_count_w"
                        >(<span class="score_count">{{ book.reviewCount }}</span
                        >)<span class="blind">{{
                          $t('common.ui.people')
                        }}</span></span
                      >
                    </span>
                  </p>

                  <div class="w-100 my-1">
                    {{
                      $t('views.library.mynotedetail.4973', {
                        '1': note.noteAuthor
                      })
                    }}
                  </div>

                  <div class="meta_detail">
                    <dl>
                      <dt>{{ $t('views.library.mynotedetail.6798') }}</dt>
                      <dd>{{ note.purchaseDate }}</dd>
                      <dt>{{ $t('views.library.mynotedetail.7782') }}</dt>
                      <dd>{{ note.lastEditDate }}</dd>
                      <dt>{{ $t('views.library.mynotedetail.3989') }}</dt>
                      <dd>{{ note.lastOpenedDate }}</dd>
                      <dt>{{ $t('views.library.mynotedetail.774') }}</dt>
                      <dd>{{ note.lastReadPage }}p</dd>
                    </dl>
                  </div>
                </div>
              </div>

              <div class="btn_wrap">
                <div class="bdsi_f0">
                  <a href="javascript:void(0)" class="box_btn"
                    ><span class="an_t">{{
                      $t('views.library.mynotedetail.9536')
                    }}</span></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ************* -->
    <!-- SELECTOR TABS -->
    <!-- ************* -->
    <div class="section fill pb">
      <div class="inner">
        <!-- Tab START -->
        <div class="link_tab">
          <ul>
            <li :class="{ active: activeTab == 1 }">
              <a class="link_tab_menu" @click="setActiveTab(1)"
                >요청 <span class="mblind">받은</span> 목록</a
              >
            </li>
            <li :class="{ active: activeTab == 2 }">
              <a class="link_tab_menu" @click="setActiveTab(2)"
                >공유<span class="mblind">중인</span> 목록</a
              >
            </li>
            <li :class="{ active: activeTab == 3 }">
              <a class="link_tab_menu" @click="setActiveTab(3)"
                ><span class="mblind">공유</span
                >{{ $t('views.library.mynotedetail.7460') }}</a
              >
            </li>
          </ul>
        </div>

        <!-- ****************** -->
        <!-- TAB 1 (요청 받은 목록) -->
        <!-- ****************** -->
        <div v-if="activeTab === 1" class="tab_detail">
          <div class="tab_page" data-tab-content="share_request">
            <div class="note_share">
              <div class="share_top">
                <div v-if="shareRequests.length > 1" class="text_label">
                  <label
                    ><input
                      type="checkbox"
                      class="chk_agree"
                      @click="selectAll(requested)"
                    /><em></em><span>전체</span></label
                  >
                </div>

                <div v-if="shareRequests.length > 1" class="btn_wrap">
                  <button
                    type="button"
                    class="box_btn dull"
                    @click="rejectSelected()"
                  >
                    <span class="an_t">{{
                      $t('views.library.mynotedetail.7294')
                    }}</span>
                  </button>
                  <button
                    type="button"
                    class="box_btn"
                    @click="acceptSelected()"
                  >
                    <span class="an_t">{{
                      $t('views.library.mynotedetail.9682')
                    }}</span>
                  </button>
                </div>
              </div>

              <div class="share_detail">
                <div
                  v-for="(request, id) in shareRequests"
                  :key="id"
                  class="share_box no-select"
                >
                  <div class="text_label">
                    <label>
                      <input
                        type="checkbox"
                        :value="request.id"
                        class="chk_agree"
                      /><em></em><span>선택</span>
                      <div class="share_user">
                        <img
                          class="photo"
                          :src="request.user.img"
                          :alt="request.user.name"
                        />
                        <div class="txtbox">
                          <p class="name">{{ request.user.name }}</p>
                          <p class="belong">{{ request.user.school }}</p>
                          <p class="date">
                            {{
                              $t('views.library.mynotedetail.7535', {
                                '1': request.requestDate
                              })
                            }}
                          </p>
                        </div>
                      </div>
                    </label>
                  </div>

                  <div class="btn_wrap">
                    <button
                      type="button"
                      class="box_btn dull"
                      @click="rejectRequest(id)"
                    >
                      <span class="an_t">거절</span>
                    </button>
                    <button
                      type="button"
                      class="box_btn"
                      @click="acceptRequest(id)"
                    >
                      <span class="an_t">수락</span>
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="!shareRequests.length" class="not_share">
                <p>{{ $t('views.library.mynotedetail.3788') }}</p>
              </div>

              <!-- TODO: ADD PAGINATION -->
              <div class="board_pagemove_wrap">
                <div class="board_pagemove">
                  <a href="javascript:void(0)" class="first"
                    ><span>{{ $t('common.ui.firest') }}</span></a
                  >
                  <a href="javascript:void(0)" class="prev"
                    ><span>{{ $t('common.ui.previous') }}</span></a
                  >

                  <ul>
                    <li class="on"><a href="javascript:void(0)">1</a></li>
                    <li><a href="javascript:void(0)">2</a></li>
                    <li><a href="javascript:void(0)">3</a></li>
                    <li><a href="javascript:void(0)">4</a></li>
                    <li><a href="javascript:void(0)">5</a></li>
                    <li><a href="javascript:void(0)">6</a></li>
                    <li><a href="javascript:void(0)">7</a></li>
                    <li><a href="javascript:void(0)">8</a></li>
                    <li><a href="javascript:void(0)">9</a></li>
                    <li><a href="javascript:void(0)">10</a></li>
                  </ul>
                  <a href="javascript:void(0)" class="next"
                    ><span>{{ $t('common.ui.next') }}</span></a
                  >
                  <a href="javascript:void(0)" class="end"
                    ><span>{{ $t('views.library.mynotedetail.7231') }}</span></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ***************** -->
        <!-- TAB 2 (공유중인 목록) -->
        <!-- ****************** -->
        <div v-if="activeTab === 2" class="tab_detail">
          <div class="tab_page" data-tab-content="share_complete">
            <div class="note_share">
              <div class="share_top">
                <div v-if="shareRequests.length > 1" class="text_label">
                  <label
                    ><input
                      type="checkbox"
                      class="chk_agree"
                      @click="selectAll(shared)"
                    /><em></em><span>전체</span></label
                  >
                </div>

                <div v-if="shareRequests.length > 1" class="btn_wrap">
                  <button type="button" class="box_btn" @click="rejectSelected">
                    <span class="an_t">{{
                      $t('views.library.mynotedetail.2354')
                    }}</span>
                  </button>
                </div>
              </div>

              <div class="share_detail">
                <div
                  v-for="(request, id) in shareRequests"
                  :key="id"
                  class="share_box accept no-select"
                >
                  <div class="text_label">
                    <label>
                      <input
                        type="checkbox"
                        :value="request.id"
                        class="chk_agree"
                      /><em></em><span>선택</span>
                      <div class="share_user">
                        <img
                          class="photo"
                          :src="request.user.img"
                          :alt="request.user.name"
                        />
                        <div class="txtbox">
                          <p class="name">{{ request.user.name }}</p>
                          <p class="belong">{{ request.user.school }}</p>
                          <p class="date">
                            {{
                              $t('views.library.mynotedetail.9252', {
                                '1': request.requestDate
                              })
                            }}
                          </p>
                        </div>
                      </div>
                    </label>
                  </div>

                  <div class="btn_wrap">
                    <button
                      type="button"
                      class="box_btn dull"
                      @click="rejectRequest(id)"
                    >
                      <span class="an_t">{{
                        $t('views.library.mynotedetail.6277')
                      }}</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- SHOW IF NO ITEMS AVAILABLE -->
              <div v-if="!shareRequests.length" class="not_share">
                <p>{{ $t('views.library.mynotedetail.6828') }}</p>
              </div>

              <!-- TODO: ADD PAGINATION -->
              <div class="board_pagemove_wrap">
                <div class="board_pagemove">
                  <a href="javascript:void(0)" class="first"
                    ><span>{{ $t('common.ui.first') }}</span></a
                  >
                  <a href="javascript:void(0)" class="prev"
                    ><span>{{ $t('common.ui.previous') }}</span></a
                  >

                  <ul>
                    <li class="on"><a href="javascript:void(0)">1</a></li>
                    <li><a href="javascript:void(0)">2</a></li>
                    <li><a href="javascript:void(0)">3</a></li>
                    <li><a href="javascript:void(0)">4</a></li>
                    <li><a href="javascript:void(0)">5</a></li>
                    <li><a href="javascript:void(0)">6</a></li>
                    <li><a href="javascript:void(0)">7</a></li>
                    <li><a href="javascript:void(0)">8</a></li>
                    <li><a href="javascript:void(0)">9</a></li>
                    <li><a href="javascript:void(0)">10</a></li>
                  </ul>
                  <a href="javascript:void(0)" class="next"
                    ><span>{{ $t('common.ui.next') }}</span></a
                  >
                  <a href="javascript:void(0)" class="end"
                    ><span>{{ $t('views.library.mynotedetail.5299') }}</span></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ****************** -->
        <!-- TAB 3 (공유 취소 목록) -->
        <!-- ****************** -->
        <div v-if="activeTab === 3" class="tab_detail">
          <div class="tab_page" data-tab-content="share_cancel">
            <div class="note_share list">
              <div class="share_top">
                <div v-if="shareRequests.length > 1" class="text_label">
                  <label
                    ><input
                      type="checkbox"
                      class="chk_agree"
                      @click="selectAll(rejected)"
                    /><em></em><span>전체</span></label
                  >
                </div>

                <div v-if="shareRequests.length > 1" class="btn_wrap">
                  <button type="button" class="box_btn" @click="acceptSelected">
                    <span class="an_t">{{
                      $t('views.library.mynotedetail.3843')
                    }}</span>
                  </button>
                </div>
              </div>

              <!-- 공유 취소된 아이템 -->
              <div class="share_detail">
                <div
                  v-for="(request, id) in shareRequests"
                  :key="id"
                  class="share_box no-select"
                >
                  <div class="text_label">
                    <label>
                      <input
                        type="checkbox"
                        class="chk_agree"
                        @click="selectAll(shared)"
                      /><em></em><span>선택</span>
                      <div class="share_user">
                        <img
                          class="photo"
                          :src="request.user.img"
                          :alt="request.user.name"
                        />
                        <div class="txtbox">
                          <p class="name">{{ request.user.name }}</p>
                          <p class="belong">{{ request.user.school }}</p>
                          <p class="date">
                            {{
                              $t('views.library.mynotedetail.8996', {
                                '1': request.requestDate
                              })
                            }}
                          </p>
                        </div>
                      </div>
                    </label>
                  </div>

                  <div class="btn_wrap">
                    <button
                      type="button"
                      class="box_btn"
                      @click="acceptRequest(id)"
                    >
                      <span class="an_t">{{
                        $t('views.library.mynotedetail.5958')
                      }}</span>
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="!shareRequests.length" class="not_share">
                <p>{{ $t('views.library.mynotedetail.4394') }}</p>
              </div>

              <!-- TODO: ADD PAGINATION -->
              <div class="board_pagemove_wrap mt0">
                <div class="board_pagemove">
                  <a href="javascript:void(0)" class="first"
                    ><span>{{ $t('common.ui.first') }}</span></a
                  >
                  <a href="javascript:void(0)" class="prev"
                    ><span>{{ $t('common.ui.previous') }}</span></a
                  >
                  <ul>
                    <li class="on"><a href="javascript:void(0)">1</a></li>
                    <li><a href="javascript:void(0)">2</a></li>
                    <li><a href="javascript:void(0)">3</a></li>
                    <li><a href="javascript:void(0)">4</a></li>
                    <li><a href="javascript:void(0)">5</a></li>
                    <li><a href="javascript:void(0)">6</a></li>
                    <li><a href="javascript:void(0)">7</a></li>
                    <li><a href="javascript:void(0)">8</a></li>
                    <li><a href="javascript:void(0)">9</a></li>
                    <li><a href="javascript:void(0)">10</a></li>
                  </ul>
                  <a href="javascript:void(0)" class="next"
                    ><span>{{ $t('common.ui.next') }}</span></a
                  >
                  <a href="javascript:void(0)" class="end"
                    ><span>{{ $t('views.library.mynotedetail.1661') }}</span></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Review -->
    <ReviewBox :book="note" :add-review="false" />
  </div>
</template>

<script>
import ReviewBox from '@/components/library/ReviewBox.vue'

export default {
  name: 'MyNoteDetail',

  components: { ReviewBox },
  data() {
    return {
      showListMenu: false,
      selected: [],
      activeTab: 1,
      book: {
        title: 'Book Title',
        author: 'Book Author',
        publisher: 'Book Publisher',
        date: '2020.05.19',
        rating: 3.5,
        reviewCount: 75,
        hasEbook: true,
        hasPaper: true,
        hasPod: false
      },
      note: {
        id: '12345',
        sharing: true,
        isBest: true,
        title: '세계의 몸짓 몸짓의 세계',
        author: '권경애, 김형래, 박경은, 송승원, 임대근',
        noteAuthor: 'Bobby Boucher',
        publisher: '한국외국어대학교 지식출판원',
        publishedDate: '',
        rating: 3.5,
        reviewCount: 40,
        hasPaper: true,
        hasEbook: true,
        hasPod: false,
        color: 'orange',
        purchaseDate: '2020.02.19',
        lastEditDate: '2020.02.19',
        lastOpenedDate: '2020.02.20',
        lastReadPage: 110
      },
      shareRequests: [
        {
          // user: {
          //   name: '김민주',
          //   img: require('@/assets/images/guide/profile.png'),
          //   school: '이화여자대학교'
          // },

          shareStatus: 'shared',
          requestDate: '2020.05.15',
          acceptedDate: '2020.05.16',
          cancelDate: '2020.05.17'
        },
        {
          // user: {
          //   name: '김민주',
          //   img: require('@/assets/images/guide/profile.png'),
          //   school: '이화여자대학교'
          // },

          shareStatus: 'shared',
          requestDate: '2020.05.15',
          acceptedDate: '2020.05.16',
          cancelDate: '2020.05.17'
        },
        {
          // user: {
          //   name: '김민주',
          //   img: require('@/assets/images/guide/profile.png'),
          //   school: '이화여자대학교'
          // },

          shareStatus: 'rejected',
          requestDate: '2020.05.15',
          acceptedDate: '2020.05.16',
          cancelDate: '2020.05.17'
        },
        {
          // user: {
          //   name: '김민주',
          //   img: require('@/assets/images/guide/profile.png'),
          //   school: '이화여자대학교'
          // },

          shareStatus: 'requested',
          requestDate: '2020.05.15',
          acceptedDate: '2020.05.16',
          cancelDate: '2020.05.17'
        },
        {
          // user: {
          //   name: '김민주',
          //   img: require('@/assets/images/guide/profile.png'),
          //   school: '이화여자대학교'
          // },

          shareStatus: 'requested',
          requestDate: '2020.05.15',
          acceptedDate: '2020.05.16',
          cancelDate: '2020.05.17'
        },
        {
          // user: {
          //   name: '김민주',
          //   img: require('@/assets/images/guide/profile.png'),
          //   school: '이화여자대학교'
          // },

          shareStatus: 'rejected',
          requestDate: '2020.05.15',
          acceptedDate: '2020.05.16',
          cancelDate: '2020.05.17'
        }
      ]
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab
    },
    rejectRequest() {},
    acceptRequest() {},

    selectAll() {
      // TODO: select all in current tab's currently paginated page
    },
    acceptSelected() {
      // TODO: set selected[] to 'shared'
    },
    rejectSelected() {
      // TODO: set selected[] to 'rejected'
    },
    closeListMenu() {
      this.showListMenu = false
    },
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    }
  }
}
</script>

<style lang="scss" scoped></style>
